import type {
  UpsertUserSearchPreferencesMutation,
  UpsertUserSearchPreferencesMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpsertUserSearchPreferencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpsertUserSearchPreferences = createMutationHook({
  name: 'upsertUserSearchPreferences',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userSearchPreferences.upsertUserSearchPreferences.mutationOptions(
      { onSuccess }
    ),
  mapInput: (input: UpsertUserSearchPreferencesMutationVariables) => ({
    ShowGroups: input.ShowGroups,
    FilterByActivePlatformUsers: input.FilterByActivePlatformUsers,
    ShowUserPlatformRole: input.ShowUserPlatformRole,
    ShowUserJobTitle: input.ShowUserJobTitle,
    ShowDirectoryDepartment: input.ShowDirectoryDepartment,
    ShowUserLocation: input.ShowUserLocation,
    ShowUserEmail: input.ShowUserEmail,
    ShowArchivedUsers: input.ShowArchivedUsers,
    ShowInheritedContributors: input.ShowInheritedContributors,
  }),
  invalidate: (trpc) => [
    trpc.frontend.userSearchPreferences.getUserSearchPreferences.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): UpsertUserSearchPreferencesMutation => ({
    insert_user_search_preferences: {
      __typename: 'user_search_preferences_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: UpsertUserSearchPreferencesDocument,
  graphqlVariables: (input) => ({ ...input }),
  evictFields: ['user_search_preferences'],
});
